import { bl_mlm_invitation_hdr_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";


export class MlmInvitationContainerModel extends BaseContainerModel {

    bl_mlm_invitation_hdr : bl_mlm_invitation_hdr_RowClass = new bl_mlm_invitation_hdr_RowClass();
}